import { LogService } from 'ng/src/app/logs/log.service';

angular.module('logbook').directive('reportBuilderStarter', ['$location', '$http', '$rootScope', '$route', 'reportBuilderService',
	function($location, $http, $rootScope, $route, reportBuilderService) {
		return {
			restrict: 'E',
			scope: {},
			templateUrl: 'report-builder-starter.html',

			controller: ['$scope', function($scope) {
				$scope.getTemplates = function(newReportModal) {
					$http.get('api/templates', {
						params: {
							logOrGlobal: LogService.selectedLog.id,
							projection: 'templateProjectionWithSubTemplates'
						}
					})
					.then(function(result) {
						var templates = [];
	
						result.data._embedded.templates.forEach(function(template) {
							if (template.templateType.name == 'Inspection' || !template.subTemplates.length) {
								templates.push({
									name: template.name,
									templateId: template.id
								});
							}
							else {
								// Each operational subtemplate gets its own <option> in the view
								template.subTemplates.forEach(function(subTemplate) {
									templates.push({
										name: subTemplate.name,
										parentName: template.name,
										templateId: template.id,
										subTemplateId: subTemplate.id
									});
								});
							}
						});
	
						$scope.templates = templates;
						$scope.selectedTemplate = templates[0];

						newReportModal
							.modal({ backdrop: false })
							.on('hidden.bs.modal', function(e) {
								$scope.primeNgNewReportDialog.close();
							});
					});
				};
				
				$scope.multiTemplateSelectionChanged = function() {
					if (!$scope.selectedTemplates.length) {
						$scope.setMultiTemplateNoneSelected();
						return;
					}
			
					$scope.selectedTemplatesMessage = $scope.selectedTemplates.map(function(template) {
						return template.parentName ?
							template.parentName + ' > ' + template.name :
							template.name;
					}).join(', ');
				};

				$scope.next = function() {
					// "Any Template" and "Multiple Templates" both use the Default (All Notes) report template at top level
					if ($scope.newReportTemplate == 'Single')
						sessionStorage.setItem('startingTemplate', JSON.stringify($scope.selectedTemplate));

					sessionStorage.setItem('startingRules', JSON.stringify(getQueryBuilderJSON()));

					if ($location.path() == '/report-editor' && !$location.search().draft && !$location.search().report)
						$route.reload();
					else
						$location.url('/report-editor').search('log', LogService.selectedLog.id);
				};

				$scope.setMultiTemplateNoneSelected = function() {
					$scope.selectedTemplatesMessage = 'None';

					if ($rootScope.hoverSupported)
						$scope.selectedTemplatesMessage += ' (Multiselect as many templates as you need with the keyboard)';
				};

				function getQueryBuilderJSON() {
					var reportJSON = {
						condition: $scope.timeframe == 'Any Timeframe' && $scope.newReportTemplate == 'Multiple' ? 'OR' : 'AND',
						rules: []
					};

					if ($scope.timeframe != 'Any Timeframe') {
						reportJSON.rules.push({
							data: {
								allowConfigureOnQuery: true
							},
							id: 'note-timeframe',
							field: 'note-timeframe',
							operator: reportBuilderService.getOperatorForTimeframe($scope.timeframe),
							value: reportBuilderService.noteTimeframe.valueGetter()
						});
					}

					if ($scope.newReportTemplate == 'Multiple') {
						var templateGroups = [];

						$scope.selectedTemplates.forEach(function(template) {
							var templateGroup = {
								condition: 'AND',
								data: {
									templateConstraint: template.subTemplateId ?
										template.subTemplateId + 'S' :
										template.templateId + 'T'
								},
								rules: [{
									data: {
										htmlTemplateId: 'template',
										allowConfigureOnQuery: false
									},
									id: 'template',
									field: 'template',
									operator: 'is-template',
									value: {
										templateId: template.templateId,
										subTemplateId: template.subTemplateId
									}
								}]
							};

							for (var i = 0; i < $scope.startingFields; i++)
								templateGroup.rules.push({ empty: true });
							
							templateGroups.push(templateGroup);
						});

						if ($scope.timeframe == 'Any Timeframe') {
							templateGroups.forEach(function(templateGroup) {
								reportJSON.rules.push(templateGroup);
							});
						}
						else {
							reportJSON.rules.push({
								condition: 'OR',
								rules: templateGroups
							});
						}
					}
					else {
						for (var i = 0; i < $scope.startingFields; i++)
							reportJSON.rules.push({ empty: true })
					}

					return reportJSON;
				}
			}],

			link: function(scope, element) {
				var $timeframeContainer = element.find('#timeframe-container'),
					$numberInputs = $timeframeContainer.find('input[type="number"]'),
					$dateTimePickers = $timeframeContainer.find('.input-group.date');
				
				element.find('.input-group.date').datetimepicker({
					format: 'L',
					showTodayButton: true,
					showClear: true,
					showClose: true,
					allowInputToggle: true
				});

				element.find('[data-toggle="popover"]').popover({
					html: true,
					animation: false, // prevents bug with hover not working consistently
					trigger: $rootScope.hoverSupported ? 'hover' : 'focus',
					container: '#new-report-modal',
				});

				scope.getTemplates(element.children());

				$numberInputs.each(function() {
					this.value = this.id == 'from-days-ago' ? 14 : '';
				});
					
				$dateTimePickers.each(function() {
					$(this).data('DateTimePicker').clear();
				});
	
				scope.startingFields = 1;
				scope.timeframe = 'Between Days Ago';
				scope.newReportTemplate = 'Any';
				scope.selectedTemplates = [];
				scope.setMultiTemplateNoneSelected();
			}
		}
	}
]);
